import { FeatureFlagKey } from "../../models/featureFlag";

/**
 * Nombre corto de cada característica: es lo que va en el encabezado de la
 * sección colapsable y en el toast al guardar.
 *
 * Antes acá vivía la descripción completa, que como título de acordeón ocupaba
 * dos renglones y dejaba la lista de flags imposible de barrer con la vista. El
 * detalle no se perdió: pasa a FEATURE_FLAG_DESCRIPTIONS, que se muestra dentro
 * de la sección.
 */
export const FEATURE_FLAG_LABELS: Record<FeatureFlagKey, string> = {
  post_inscription_step: "Eventos relacionados tras inscribirse",
  notif_saved_event_reminder: "Recordatorio de eventos guardados",
  notif_spot_available: "Aviso de cupos disponibles",
  notif_viewed_not_saved: "Recordatorio de eventos vistos",
  notif_slot_opened: "Aviso al liberarse un cupo",
  track_event_views: "Registro de vistas de eventos",
  admin_event_cancellation: "Cancelación de eventos desde el BO",
  admin_tipo_datos: "Configuración > Tipo de datos",
  attendance_manual_enabled: "Asistencia manual en eventos",
  attendance_bo_section_enabled: "Asistencias en el backoffice",
  gamification_points_enabled: "Puntos: acumulación",
  gamification_rewards_enabled: "Puntos: canje de premios",
};

/**
 * Qué hace exactamente cada característica. Se muestra al abrir la sección:
 * quien activa un flag necesita saber a quién le llega y cuándo, y eso no entra
 * en el nombre corto.
 */
export const FEATURE_FLAG_DESCRIPTIONS: Record<FeatureFlagKey, string> = {
  post_inscription_step:
    "Pantalla post-inscripción con hasta 4 recomendaciones de eventos relacionados.",
  notif_saved_event_reminder:
    "Recordatorio diario 10:00 — eventos guardados sin inscripción que empiezan en ≤7 días.",
  notif_spot_available:
    "Recordatorio diario 11:00 — cupos disponibles en eventos guardados con cierre de inscripción en 3–5 días.",
  notif_viewed_not_saved:
    "Eventos vistos hace 4–24 h, no guardados y sin inscripción.",
  notif_slot_opened:
    "Push al liberarse un cupo a los usuarios que vieron el evento cuando estaba lleno.",
  track_event_views: "Registra cuando un usuario mira el detalle del evento.",
  admin_event_cancellation:
    "Cancelación de eventos desde el BO con motivo tipificado (modal + detalle de la cancelación).",
  admin_tipo_datos:
    "Habilita Configuración > Tipo de datos, el ABM de tipos de cancelación.",
  attendance_manual_enabled:
    "Habilita configurar y tomar asistencia en los eventos: sección Asistencia en el formulario del evento y registro manual desde el BO.",
  attendance_bo_section_enabled:
    "Habilita la sección Asistencias en el menú del backoffice, con el listado, el historial por persona y la exportación.",
  gamification_points_enabled:
    "Habilita el motor de puntos: los usuarios suman puntos según las reglas y el backoffice muestra la sección Puntos.",
  gamification_rewards_enabled:
    "Habilita el catálogo de premios y el canje de puntos en la app.",
};

export const FEATURE_FLAG_ORDER: FeatureFlagKey[] = [
  "post_inscription_step",
  "notif_saved_event_reminder",
  "notif_spot_available",
  "notif_viewed_not_saved",
  "notif_slot_opened",
  "track_event_views",
  "admin_event_cancellation",
  "admin_tipo_datos",
  "attendance_manual_enabled",
  "attendance_bo_section_enabled",
  "gamification_points_enabled",
  "gamification_rewards_enabled",
];

/**
 * Se evalúan por tenant, sin rollout por usuario: el porcentaje de alcance no
 * aplica y la pantalla no muestra su control. El PUT igual exige rolloutPct.
 */
export const FEATURE_FLAGS_WITHOUT_ROLLOUT: FeatureFlagKey[] = [
  "gamification_points_enabled",
  "gamification_rewards_enabled",
];
